<template>
    <div class="filtro-articulos">
        <v-menu
            top
            v-model="menuFiltro"
            absolute
            offset-x
            :close-on-content-click="false"
            :close-on-click="true"
            style="width: 250px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="white" class="ml-2">
                    <v-icon style="font-size:26px">mdi-filter-menu</v-icon>
                </v-btn>
            </template>
            <v-list class="text-start">
                <v-divider class="orange mx-1" dark />
                <v-subheader>Ordenar por</v-subheader>
                <v-list-item-group v-model="orden" active-class="">
                    <v-list-item color="orange">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox color="orange" :input-value="active" />
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Mayor precio</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                    <v-divider class="mb-2 mx-1" />
                    <v-list-item color="orange">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox color="orange" :input-value="active" />
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Menor precio</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                </v-list-item-group>
                <v-divider class="orange mx-1" dark />
                <v-subheader>Filtrar por</v-subheader>
                <v-list-item-group>
                    <v-list-item @change="abrirDialogo('marca')">
                        <v-list-item-content>
                            <v-list-item-title>Marca</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mb-2 mx-1" />
                    <v-list-item @change="abrirDialogo('modelo')">
                        <v-list-item-content>
                            <v-list-item-title>Modelo</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mb-2 mx-1" />
                    <v-list-item @change="abrirDialogo('medida')">
                        <v-list-item-content>
                            <v-list-item-title>Medida</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
                <v-divider class="orange mx-1" dark />
            </v-list>
        </v-menu>

        <v-dialog v-model="dialogMarca" scrollable max-width="300px">
            <v-card>
                <v-card-title>Seleccionar marca</v-card-title>
                <v-divider />
                <v-card-text style="height: 500px;">
                    <v-list-item-group v-model="marcasSelected" multiple>
                        <v-list-item color="orange" v-for="item in marcas" :key="item" :value="item" style="height: 80px">
                            <template v-slot:default="{ active }">
                                <v-list-item-action>
                                    <v-checkbox :input-value="active" color="orange" />
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item" />
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogModelo" scrollable max-width="400px">
            <v-card>
                <v-card-title>Seleccionar modelo</v-card-title>
                <v-divider />
                <v-card-text style="height: 500px;">
                    <v-list-item-group v-model="modelosSelected" multiple>
                        <v-list-item color="orange" v-for="item in modelos" :key="item" :value="item" style="height: 80px">
                            <template v-slot:default="{ active }">
                                <v-list-item-action>
                                    <v-checkbox :input-value="active" color="orange" />
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item" />
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogMedida" scrollable max-width="310px">
            <v-card>
                <v-card-title>Seleccionar medida</v-card-title>
                <v-divider />
                <v-card-text style="height: 500px;">
                    <v-list-item-group v-model="medidasSelected" multiple>
                        <v-list-item color="orange" v-for="item in medidas" :key="item" :value="item" style="height: 80px">
                            <template v-slot:default="{ active }">
                                <v-list-item-action>
                                    <v-checkbox :input-value="active" color="orange" />
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item" />
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'FiltroArticulos',
    props: {
        articulos: {
            type: Array,
            default: () => []
        },
        getPrecio: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            menuFiltro: false,
            dialogMarca: false,
            dialogModelo: false,
            dialogMedida: false,
            marcas: [],
            modelos: [],
            medidas: [],
            marcasSelected: [],
            modelosSelected: [],
            medidasSelected: [],
            orden: 0,
            saltarWatchSeleccion: false
        }
    },
    watch: {
        articulos: {
            handler() {
                this.resetYArmar()
            },
            immediate: true
        },
        marcasSelected() {
            if (!this.saltarWatchSeleccion) this.filtrar()
        },
        modelosSelected() {
            if (!this.saltarWatchSeleccion) this.filtrar()
        },
        medidasSelected() {
            if (!this.saltarWatchSeleccion) this.filtrar()
        },
        orden() {
            if (!this.saltarWatchSeleccion) this.filtrar()
        }
    },
    methods: {
        abrirDialogo(tipo) {
            this.dialogMarca = tipo === 'marca'
            this.dialogModelo = tipo === 'modelo'
            this.dialogMedida = tipo === 'medida'
            this.menuFiltro = false
        },
        resetYArmar() {
            this.saltarWatchSeleccion = true
            this.marcasSelected = []
            this.modelosSelected = []
            this.medidasSelected = []
            this.orden = 0
            this.menuFiltro = false
            this.dialogMarca = false
            this.dialogModelo = false
            this.dialogMedida = false
            this.armarOpcionesFiltro(this.articulos)
            this.$nextTick(() => {
                this.saltarWatchSeleccion = false
                this.filtrar()
            })
        },
        armarOpcionesFiltro(lista) {
            this.marcas = []
            this.modelos = []
            this.medidas = []
            ;(Array.isArray(lista) ? lista : []).forEach((element) => {
                if (element.MARCA && this.marcas.findIndex((i) => i == element.MARCA) === -1) {
                    this.marcas.push(element.MARCA)
                }
                if (element.MOD && this.modelos.findIndex((i) => i == element.MOD) === -1) {
                    this.modelos.push(element.MOD)
                }
                if (element.MED && this.medidas.findIndex((i) => i == element.MED) === -1) {
                    this.medidas.push(element.MED)
                }
            })
        },
        filtrar() {
            const fuente = Array.isArray(this.articulos) ? this.articulos : []
            let listaArticulos = []
            let listaArticulos1 = []
            let listaArticulos2 = []
            let resultado = []

            if (this.marcasSelected.length > 0 || this.modelosSelected.length > 0 || this.medidasSelected.length > 0) {
                this.marcasSelected.forEach((element) => {
                    fuente.forEach((art) => {
                        if (art.MARCA == element) listaArticulos.push(art)
                    })
                })
                if (listaArticulos.length > 0) {
                    this.modelosSelected.forEach((mod) => {
                        listaArticulos.forEach((art) => {
                            if (art.MOD == mod) listaArticulos1.push(art)
                        })
                    })
                } else {
                    this.modelosSelected.forEach((mod) => {
                        fuente.forEach((art) => {
                            if (art.MOD == mod) listaArticulos1.push(art)
                        })
                    })
                }
                if (listaArticulos1.length > 0) {
                    this.medidasSelected.forEach((med) => {
                        listaArticulos1.forEach((art) => {
                            if (art.MED == med) listaArticulos2.push(art)
                        })
                    })
                } else if (listaArticulos.length > 0) {
                    this.medidasSelected.forEach((med) => {
                        listaArticulos.forEach((art) => {
                            if (art.MED == med) listaArticulos2.push(art)
                        })
                    })
                } else {
                    this.medidasSelected.forEach((med) => {
                        fuente.forEach((art) => {
                            if (art.MED == med) listaArticulos2.push(art)
                        })
                    })
                }
                if (this.medidasSelected.length > 0) {
                    resultado = listaArticulos2
                } else if (this.modelosSelected.length > 0) {
                    resultado = listaArticulos1
                } else {
                    resultado = listaArticulos
                }
            } else {
                resultado = fuente.slice()
            }

            if (this.orden == 1) {
                resultado.sort((a, b) => this.getPrecio(a) - this.getPrecio(b))
            } else {
                resultado.sort((a, b) => this.getPrecio(b) - this.getPrecio(a))
            }
            this.$emit('update:filtrados', resultado)
        }
    }
}
</script>

<style scoped>
.filtro-articulos {
    display: flex;
    align-items: center;
    height: 44px;
}
</style>
